import { toast } from "sonner";
import { API_ENDPOINTS, HTTP_METHODS } from "../config/api";
import { BaseApiService, ApiResponse } from "./baseApi";

// Sales Order Performance Report DTO
export interface SalesOrderPerformanceDto {
  // Sales Order Information
  salesOrderId?: number;
  salesOrderNumber?: string;
  orderDate?: string; // LocalDateTime
  salesOrderStatus?: string;
  effectiveStartDate?: string; // LocalDateTime
  effectiveEndDate?: string; // LocalDateTime
  
  // Branch Information
  branchId?: number;
  branchName?: string;
  branchCode?: string;
  
  // Customer Information
  customerId?: number;
  customerName?: string;
  customerCode?: string;
  
  // Sales Order Detail Information
  salesOrderDetailId?: number;
  
  // Endgood Information
  endgoodId?: number;
  endgoodName?: string;
  endgoodSku?: string;
  
  // Performance Metrics
  orderedQuantity?: number;
  packedQuantity?: number;
  wipQuantity?: number;
  invoicedQuantity?: number;
  pendingQuantity?: number;
  completionPercentage?: number;
  
  // Activity Tracking
  lastActivityDate?: string; // LocalDateTime
}

// Sales Order Report API Service
class SalesOrderReportApiService extends BaseApiService {
  
  // Get sales order performance report by branch
  async getSalesOrderPerformanceReport(
    branchId?: number,
    startDate?: string,
    endDate?: string
  ): Promise<ApiResponse<SalesOrderPerformanceDto[]>> {
    try {
      // Backend returns List directly, not wrapped in ApiResponse
      const data = await this.makeRequest<SalesOrderPerformanceDto[]>(
        API_ENDPOINTS.SALES_ORDER_REPORTS.PERFORMANCE(branchId, startDate, endDate),
        { method: HTTP_METHODS.GET }
      );
      
      // Wrap in ApiResponse format for consistency
      return {
        success: true,
        message: 'Sales order performance report fetched successfully',
        data: Array.isArray(data) ? data : []
      };
    } catch (error) {
      // console.error('SalesOrderReportApiService: Error fetching sales order performance report:', error);
      toast.error('Failed to fetch sales order performance report');
      throw error;
    }
  }

  // Get sales order detail by ID (for detailed view)
  async getSalesOrderDetail(salesOrderId: number): Promise<ApiResponse<SalesOrderPerformanceDto[]>> {
    try {
      const data = await this.makeRequest<SalesOrderPerformanceDto[]>(
        API_ENDPOINTS.SALES_ORDER_REPORTS.DETAIL(salesOrderId),
        { method: HTTP_METHODS.GET }
      );
      
      return {
        success: true,
        message: 'Sales order detail fetched successfully',
        data: Array.isArray(data) ? data : []
      };
    } catch (error) {
      // console.error('SalesOrderReportApiService: Error fetching sales order detail:', error);
      toast.error('Failed to fetch sales order detail');
      throw error;
    }
  }
}

export const salesOrderReportApiService = new SalesOrderReportApiService();

